import React, { Component } from 'react'
import MaterialAvatar from 'material-ui/Avatar'
import AccountCircle from 'material-ui-icons/AccountCircle'

const styles = {
  bigAvatar: {
    width: 96,
    height: 96
  },
  bigIcon:{
    fontSize: 80
  }
}

type Props = {
  url?: string,
  alt?: string,
  large?: boolean
}

class Avatar extends Component<Props> {
  render() {
    const {
      large,
      url,
      alt,
      ...rest
    } = this.props

    return (
      <MaterialAvatar
        style={large && styles.bigAvatar}
        {...rest}
      >
        {url
          ? <img src={url} alt={alt} />
          : <AccountCircle style={large && styles.bigIcon} />
        }
      </MaterialAvatar>
    )
  }
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.js